export default ['1494F0', '79D7FF', '25D19E', 'FF9950', '7A60E3', 'F8ACFF'];
